import { css } from 'linaria';

export const pimDisclaimerSection = css`
  margin: var(--space-500) 0;

  @media (--only-mobile) {
    margin: var(--space-200);
  }
`;
